import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Modal, Switch, Upload } from 'antd';
import axios from 'axios';
import { memo, useCallback, useContext, useMemo, useState } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { apiUrl } from '../../utils/constants';

const Setting = ({ openSetting, setOpenSetting, handleOpenShowQR }) => {
  const {
    authState: { user },
    loadUser,
    logoutUser,
  } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [loading2FA, setLoading2FA] = useState(false);
  const [isChecked, setIsChecked] = useState(user.isTwoFactorEnabled);
  const [imageUrl, setImageUrl] = useState(user?.avatar || null);

  const getBase64 = useCallback((img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }, []);

  const uploadProps = useMemo(
    () => ({
      name: 'file',
      action: `${apiUrl}/users/avatar`,
      headers: {
        Authorization: axios?.defaults?.headers?.common['Authorization'],
        'x-yumyum-key': `${process.env.REACT_APP_X_YUMYUM_KEY}`,
      },
      method: 'put',
      showUploadList: false,

      beforeUpload: (file) => {
        const isPNG = file?.type === 'image/jpeg';
        if (!isPNG) {
          console.error(`${file?.name} is not a jpeg file`);
        }
        return isPNG || Upload?.LIST_IGNORE;
      },

      onChange(info) {
        if (info?.file?.status !== 'uploading') {
          setLoading(true);
          console.log(info?.file, info?.fileList);
        }
        if (info?.file?.status === 'done') {
          console.log(`${info?.file?.name} file uploaded successfully`);
          getBase64(info.file.originFileObj, (url) => {
            setLoading(false);
            setImageUrl(url);
          });
          loadUser();
        } else if (info?.file?.status === 'error') {
          console.error(`${info?.file?.name} file upload failed.`);
        }
      },
    }),
    [getBase64, loadUser]
  );

  const uploadButton = useMemo(
    () => (
      <div
        style={{
          cursor: 'pointer',
        }}
      >
        {loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div
          style={{
            marginTop: 8,
          }}
        >
          Upload
        </div>
      </div>
    ),
    [loading]
  );

  const closeModal = useCallback(() => {
    setOpenSetting(false);
    setLoading(false);
    setLoading2FA(false);
    setImageUrl(user?.avatar || null);
    setIsChecked(user.isTwoFactorEnabled);
  }, [setOpenSetting, user?.avatar, user.isTwoFactorEnabled]);

  const onChangeCheckSwitch = useCallback(
    async (checked, _event) => {
      setIsChecked(checked);
      setLoading2FA(true);
      if (user.isTwoFactorEnabled !== checked) {
        if (checked) {
          handleOpenShowQR();
          closeModal();
        } else {
          await axios.put(`${apiUrl}/2fa/turn-off`);
          logoutUser();
        }
      }
    },
    [closeModal, handleOpenShowQR, logoutUser, user.isTwoFactorEnabled]
  );

  return (
    <Modal
      afterClose={closeModal}
      open={openSetting}
      title="Setting"
      onCancel={() => setOpenSetting(false)}
      footer={[
        <Button key="back" danger onClick={closeModal}>
          Close
        </Button>,
      ]}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '20px',
        }}
      >
        <p>Avatar</p>
        <Upload {...uploadProps}>
          {imageUrl ? (
            <img
              src={imageUrl}
              alt="avatar"
              style={{
                width: '100%',
                cursor: 'pointer',
              }}
            />
          ) : (
            uploadButton
          )}
        </Upload>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <p>Two factor authentication</p>
        <Switch
          onChange={onChangeCheckSwitch}
          loading={loading2FA}
          checked={isChecked}
        />
      </div>
    </Modal>
  );
};

export default memo(Setting);
